/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DomainService API
 * API reference for handling domain data provided by DomainService.
 *
 * # Authentication
 * This API is stateful. Therefore, it is necessary to call with the authentication information set in the cookie.
 * More specifically, it authenticates using Auth0.
 * Please set in header before calling API
 *  - x-solution-id
 *  - x-client-id
 *  - Authorization
 *  - Cookie.
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  BaseSuccessResponse,
  CheckResp,
  ContextResp
} from '../model';

import healthCheckMutator from '../../../mutators/domain-service-instance';
import commonCheckMutator from '../../../mutators/domain-service-instance';
import commonContextMutator from '../../../mutators/domain-service-instance';



  /**
 * Check health of domain service.
 * @summary Check service healthcheck
 */
export const healthCheck = (

 ) => {
      return healthCheckMutator<BaseSuccessResponse>(
      {url: `/common/healthcheck`, method: 'GET'
    },
      );
    }
  /**
 * Check organization and user ID
 * @summary Organization and User ID
 */
export const commonCheck = (

 ) => {
      return commonCheckMutator<CheckResp>(
      {url: `/common/check`, method: 'GET'
    },
      );
    }
  /**
 * Check organization and user context
 * @summary Organization and User Context
 */
export const commonContext = (

 ) => {
      return commonContextMutator<ContextResp>(
      {url: `/common/context`, method: 'GET'
    },
      );
    }
  export type HealthCheckResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type CommonCheckResult = NonNullable<Awaited<ReturnType<typeof commonCheck>>>
export type CommonContextResult = NonNullable<Awaited<ReturnType<typeof commonContext>>>
